import { useMemo } from 'react';
import { generateHTML, type JSONContent } from '@tiptap/core';
import { cn } from '@/lib/utils';
import { blockEditorExtensions } from './editor/blockEditorExtensions';
import { withHeadingIds } from './editor/headingOutline';

/** Renderiza o JSON do Tiptap como HTML estático — reusado pela página pública
 *  do artigo e pelo botão "Visualizar" do editor (aí a partir do estado local,
 *  sem nenhuma leitura ao Firestore). `className` deixa o chamador sobrescrever
 *  a cor do texto (ex.: prévia do editor força fundo/texto claros, sem herdar
 *  tema escuro do dashboard — ver BlogEditorPage). */
export function BlogPostView({ blocos, className }: { blocos: JSONContent; className?: string }) {
  const html = useMemo(() => {
    try {
      return generateHTML(withHeadingIds(blocos), blockEditorExtensions());
    } catch (err) {
      console.error('Falha ao renderizar conteúdo do artigo', err);
      return '';
    }
  }, [blocos]);

  // HTML gerado pelo próprio Tiptap a partir de um schema fechado (só os nós/
  // marcas que registramos em blockEditorExtensions.ts), não de input HTML
  // arbitrário de terceiros.
  return (
    <div
      className={cn(
        'prose prose-neutral max-w-none font-body text-foreground [&_h1]:font-sans [&_h2]:font-sans [&_a]:text-primary',
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
